module.exports = __webpack_public_path__ + "img/fiberconnect-bg.f0373137.svg";